import { FileTextOutlined, SearchOutlined } from '@ant-design/icons';
import {
  Breadcrumb,
  Button,
  Col,
  Input,
  Pagination,
  Popconfirm,
  Row,
  Space,
  Table,
  Tooltip,
  message
} from 'antd';
import dayjs from 'dayjs';
import { useEffect, useState,useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link, useNavigate } from 'react-router-dom';
import { ReactComponent as ArchiveRestore } from "../../Images/ArchiveRestore.svg";
import { ReactComponent as Back } from '../../Images/Back.svg';
import { ReactComponent as FilterIcon } from '../../Images/FilterIcon.svg';
import { fetchArchivedTransporterlist, resetTransporterList, unArchiveTransporter } from '../../slices/transporter';

export default function ArchiveTransporter() {

  const latestRequestIdRef = useRef(0);
    const abortControllerRef = useRef();
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [orderBy, setOrderBy] = useState('')
  const [page, setPage] = useState(1);
  const { user: currentUser } = useSelector((state) => state?.auth);
  const [pagesize, setPageSize] = useState(10);
  const navigate = useNavigate();
  const [inputValue, setInputValue] = useState(localStorage.getItem('ArchiveDieTool') || '');
  const [search, setSearch] = useState(localStorage.getItem('ArchiveDieTool') || '');

  const rowSelection = {
    selectedRowKeys,
    onChange: (selectedKeys) => {
      setSelectedRowKeys(selectedKeys);
    },
  };

  const dispatch = useDispatch();

  const { data = [], totalRecord = 0, status ,loading} = useSelector(state => state.transporter || {});
  useEffect(() => {

    if (abortControllerRef.current) {
      abortControllerRef.current.abort();
    }
    abortControllerRef.current = new window.AbortController();
    const signal = abortControllerRef.current.signal;
    latestRequestIdRef.current += 1;
    const requestId = latestRequestIdRef.current;
    dispatch(resetTransporterList());
    dispatch(fetchArchivedTransporterlist({ page, pagesize, ...(search && { search: search }), ...(orderBy && { ordering: orderBy }) , signal, requestId,}))  .then(() => {
      if (requestId === latestRequestIdRef.current) {
        // Only update if this is the latest request
      }
    });
  }, [dispatch,page, pagesize, search, orderBy]);

  const handleSearch = (e) => {
    const value = e.target.value;
    setInputValue(value);
    setSearch(value);
    localStorage.setItem('ArchiveDieTool', value);
  };

  const resetFilter = () => {
    setSearch('');
    setInputValue('');
    setOrderBy(null); // if applicable
    localStorage.removeItem('ArchiveDieTool');
    dispatch(fetchArchivedTransporterlist({ page: 1, pagesize }));
  };

  const handlePageChange = (newPage) => {
    setPage(newPage);
  };

  const handleRestore = (id) => {
    if (!id) {
      message.error('Missing ID for deletion!');
      return;
    }

    dispatch(unArchiveTransporter(id))
      .unwrap()
      .then(() => {
        message.success('Transporter Unarchived successfully!');
      })
      .catch((err) => {
        console.error('Delete Error:', err); // Debugging the error
        message.error(`Error: ${err || 'Failed to unarchive the transporter.'}`);
      });
  };

  const GetSortingEnumValue = (sortField, sortOrder) => {
    let sortingEnumKey = "id";

    if (sortField === "party_name" && sortOrder === "ascend") {
      sortingEnumKey = "party_name";
    }
    if (sortField === "party_name" && sortOrder === "descend") {
      sortingEnumKey = "-party_name";
    }
    if (sortField === "party_code" && sortOrder === "ascend") {
      sortingEnumKey = "party_code";
    }
    if (sortField === "party_code" && sortOrder === "descend") {
      sortingEnumKey = "-party_code";
    }
    if (sortField === "opening_balance" && sortOrder === "ascend") {
      sortingEnumKey = "opening_balance";
    }
    if (sortField === "opening_balance" && sortOrder === "descend") {
      sortingEnumKey = "-opening_balance";
    }
    if (sortField === "balance_type" && sortOrder === "ascend") {
      sortingEnumKey = "balance_type";
    }
    if (sortField === "balance_type" && sortOrder === "descend") {
      sortingEnumKey = "-balance_type";
    }
    if (sortField === "is_cash_amount" && sortOrder === "ascend") {
      sortingEnumKey = "is_cash_amount";
    }
    if (sortField === "is_cash_amount" && sortOrder === "descend") {
      sortingEnumKey = "-is_cash_amount";
    }
    if (sortField === "address" && sortOrder === "ascend") {
      sortingEnumKey = "address";
    }
    if (sortField === "address" && sortOrder === "descend") {
      sortingEnumKey = "-address";
    }
    if (sortField === "city" && sortOrder === "ascend") {
      sortingEnumKey = "city";
    }
    if (sortField === "city" && sortOrder === "descend") {
      sortingEnumKey = "-city";
    }
    if (sortField === "pincode" && sortOrder === "ascend") {
      sortingEnumKey = "pincode";
    }
    if (sortField === "pincode" && sortOrder === "descend") {
      sortingEnumKey = "-pincode";
    }
    if (sortField === "mobile_no_sms" && sortOrder === "ascend") {
      sortingEnumKey = "mobile_no_sms";
    }
    if (sortField === "mobile_no_sms" && sortOrder === "descend") {
      sortingEnumKey = "-mobile_no_sms";
    }
    if (sortField === "mobile_no" && sortOrder === "ascend") {
      sortingEnumKey = "mobile_no";
    }
    if (sortField === "mobile_no" && sortOrder === "descend") {
      sortingEnumKey = "-mobile_no";
    }
    if (sortField === "phone_no" && sortOrder === "ascend") {
      sortingEnumKey = "phone_no";
    }
    if (sortField === "phone_no" && sortOrder === "descend") {
      sortingEnumKey = "-phone_no";
    }
    if (sortField === "email_id" && sortOrder === "ascend") {
      sortingEnumKey = "email_id";
    }
    if (sortField === "email_id" && sortOrder === "descend") {
      sortingEnumKey = "-email_id";
    }
    if (sortField === "send_sms_type" && sortOrder === "ascend") {
      sortingEnumKey = "send_sms_type";
    }
    if (sortField === "send_sms_type" && sortOrder === "descend") {
      sortingEnumKey = "-send_sms_type";
    }
    if (sortField === "is_active" && sortOrder === "ascend") {
      sortingEnumKey = "is_active";
    }
    if (sortField === "is_active" && sortOrder === "descend") {
      sortingEnumKey = "-is_active";
    }

    return sortingEnumKey;
  };


  const handleTableChange = async (pagination, filters, sorter, ordering) => {
    if (sorter?.columnKey && sorter.order) {
      const orderBy = GetSortingEnumValue(sorter.columnKey, sorter.order);
      setOrderBy(orderBy);
    }
    setPageSize(pagination.pageSize);
  };

  const columns = [
    {
      title: 'Sr. No.',
      dataIndex: 'id',
      key: 'id',
      width: '50px',
      render: (text, record, index) => (page - 1) * pagesize + index + 1,
      sorter: false,
    },
    {
        title: "Party Name",
        dataIndex: "party_name",
        key: "party_name",
        sorter: true,
        render: (text) => text || "N/A",
      },
      {
        title: "Party Code",
        dataIndex: "party_code",
        key: "party_code",
        
        sorter: true,
        render: (text) => text || "N/A",
      },
      {
        title: "Opening Balance",
        dataIndex: "opening_balance",
        key: "opening_balance",
        
        sorter: true,
        render: (text) => <span style={{ textAlign: "end" }}>{text ?? 0}</span>,
      },
      {
        title: "Balance Type",
        dataIndex: "balance_type",
        key: "balance_type",
    
        sorter: true,
        render: (text) => text || "N/A",
      },
      {
        title: "Is This Cash Account",
        dataIndex: "is_cash_amount",
        key: "is_cash_amount",
     
        render: (val) => (val ? "Yes" : "No"),
      },
      {
        title: "Address",
        dataIndex: "address",
        key: "address",
        render: (text) => text || "N/A",
      },
      {
        title: "City",
        dataIndex: "city",
        key: "city",
        width: '110px',
        render: (text) => text || "N/A",
      },
      {
        title: "Pincode",
        dataIndex: "pincode",
        key: "pincode",
        render: (text) => text || "N/A",
      },
      {
        title: "Mobile No. (SMS)",
        dataIndex: "mobile_no_sms",
        key: "mobile_no_sms",
        width: '115px',
        render: (text) => text || "N/A",
      },
      {
        title: "Mobile No.",
        dataIndex: "mobile_no",
        key: "mobile_no",
        width: '115px',
        render: (text) => text || "N/A",
      },
      {
        title: "Phone No.",
        dataIndex: "phone_no",
        key: "phone_no",
        width: '115px',
        render: (text) => text || "N/A",
      },
      {
        title: "Email ID",
        dataIndex: "email_id",
        key: "email_id",
      
        render: (text) => text || "N/A",
      },
      {
        title: "Sending SMS Type",
        dataIndex: "send_sms_type",
        key: "send_sms_type",
        render: (text) => text || "N/A",
      },
      {
        title: "Is Active",
        dataIndex: "is_active",
        key: "is_active",
        render: (val) => (val ? "Active" : "Inactive"),
      },
    {
      title: 'Archive At',
      dataIndex: 'deleted_at',
      key: 'deleted_at',
      // width: '100px',
      sorter: true,
      render: (record) => {
        return (
          <span>{record ? dayjs(record).format('DD-MM-YYYY HH:mm') : 'N/A'} </span>
        )
      }
    },
    {
      title: 'Archive By',
      dataIndex: 'deleted_by_name',
      key: 'deleted_by_name',
      width: '100px',
      sorter: true,
      render: ((record) => {
        return (
          <span>{record ? record : 'N/A'} </span>
        )
      })
    },
    
    {
      title: 'Action',
      width: '100px',
      dataIndex: 'id', // Use `id` here for proper alignment and access
      key: 'action',
      render: (text, record) => (
        <Space>
          <Tooltip placement="top" title={"Unarchive"}>
            <Popconfirm
              title="Are you sure you want to Unarchive this record?"
              onConfirm={() => handleRestore(record?.id)} // Correctly access `id`
              onCancel={() => message.info('Action cancelled')}
              okText="Yes"
              cancelText="No"
            >
              <ArchiveRestore className="ArchiverestorImg" />
            </Popconfirm>
          </Tooltip>
        </Space>
      ),
    },

  ];

  const handlePageSizeChange = (current, size) => {
    setPage(1); // Reset to first page if needed
    setPageSize(size); // You must have a setter or state update
  };

  return (
    <>
      <div className='sticyaction'>
        <Row className="pagenamerow" justify="space-between" align="middle">
          <Col>
            <h2 style={{ margin: 0 }}>Archived Transporter</h2>
            <div className="bredcrumbwrp">
              <Link onClick={() => navigate(-1)} className="back">
                <Back /> BACK
              </Link>
              <Breadcrumb
                items={[
                  { title: <Link to="/transporter-list">Transporter List</Link> },
                  { title: 'Archive Transporter' }
                ]}
              />
            </div>
          </Col>
          <Col>
            <Space size="large">
              <Input
                placeholder="Search"
                className='searchbox'
                prefix={<SearchOutlined />}
                value={search}
                style={{ width: 200 }}
                onChange={handleSearch}
              />
              <Link>
                <Tooltip placement="top" title={'Reset Filter'}>
                  <Button type="primary" disabled={!search} className='iconlink' onClick={resetFilter}>
                    <FilterIcon />
                  </Button>
                </Tooltip>
              </Link>


            </Space>
          </Col>
        </Row>
      </div>
      <div style={{ height: '100vh', display: 'flex', flexDirection: 'column' }}>
        <div style={{ flex: 1, overflow: 'auto' }}>
          <Table
            rowKey="id"
           // rowSelection={rowSelection}
            dataSource={Array.isArray(data) ? data : []}
            columns={columns}
            pagination={false}
            loading={loading}
            onChange={handleTableChange}
             scroll={{
          x: 880, // Horizontal Scroll
          y: 400,  // Vertical Scroll with Fixed Header
        }}
          />
        </div>
        <div
          style={{
            position: 'sticky',
            bottom: 0,
            zIndex: 1000,
            background: '#fff',
            padding: 10,
            display: 'flex',
            justifyContent: 'flex-end',
          }}
        >
          <Pagination
            current={page}
            pageSize={pagesize}
            total={totalRecord}
            showSizeChanger
            onShowSizeChange={handlePageSizeChange}
            showTotal={total => `Total ${total} items`}
            onChange={handlePageChange}
            locale={{ items_per_page: 'Items / Page' }}
          />
        </div>
      </div>
    </>
  );
}
